<form
  *transloco="let t; read: 'configuration-routes.view.settings-tab'"
  [formGroup]="form"
  class="response-type__form"
>
  <div class="xi-form-group__side--left">
    <h3>{{ t('response-type-header') }}</h3>

    <p>{{ t('response-type-content') }}</p>
  </div>

  <div class="xi-form-group__side--right">
    <div class="response-type__row">
      <fieldset class="response-type__form-radio" [disabled]="!canEditRoute || !!hasAutoAnalysis">
        <xi-radio
          color="CX"
          formControlName="responseType"
          name="responseType"
          [label]="t('polling')"
          [matTooltip]="responseTypeTooltip"
          value="POLLING"
        ></xi-radio>
      </fieldset>

      <xi-tool-tip-content [tooltip]="{ text: t('polling-tooltip') }"></xi-tool-tip-content>
    </div>

    <div class="response-type__row">
      <fieldset
        class="response-type__form-radio"
        [disabled]="!canEditRoute || hasMachineTranslation || hasAutoAnalysis"
      >
        <xi-radio
          color="CX"
          formControlName="responseType"
          name="responseType"
          [label]="t('auto-response')"
          [matTooltip]="responseTypeTooltip || autoResponseTooltip"
          value="AUTORESPONSE"
        ></xi-radio>
      </fieldset>

      <xi-tool-tip-content [tooltip]="{ text: t('auto-response-tooltip') }"></xi-tool-tip-content>
    </div>

    <div class="response-type__row">
      <fieldset
        class="response-type__form-radio"
        [disabled]="!canEditRoute || hasMachineTranslation || hasAutoAnalysis"
      >
        <xi-radio
          color="CX"
          formControlName="responseType"
          name="responseType"
          [label]="t('callback')"
          [matTooltip]="responseTypeTooltip"
          value="CALLBACK"
        ></xi-radio>
      </fieldset>
      <xi-tool-tip-content [tooltip]="{ text: t('callback-tooltip') }"></xi-tool-tip-content>
    </div>

    <mat-form-field class="full-width">
      <input
        matInput
        [placeholder]="t('url')"
        formControlName="callbackUrl"
        [disabled]="!!hasAutoAnalysis"
        autocomplete="off"
      />

      <mat-hint>{{ t('url-hint') }}</mat-hint>

      @if (form.controls.callbackUrl.hasError('urlInvalid')) {
        <mat-error>
          {{ t('url-errors.invalid') }}
        </mat-error>
      }
      @if (form.controls.callbackUrl.hasError('urlNotCallback')) {
        <mat-error>
          {{ t('url-errors.not-callback') }}
        </mat-error>
      }
    </mat-form-field>
  </div>
</form>
